import { render, staticRenderFns } from "./OceanEngineAdvertiser.vue?vue&type=template&id=f8910838&scoped=true"
import script from "./OceanEngineAdvertiser.vue?vue&type=script&lang=js"
export * from "./OceanEngineAdvertiser.vue?vue&type=script&lang=js"
import style0 from "./OceanEngineAdvertiser.vue?vue&type=style&index=0&id=f8910838&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8910838",
  null
  
)

export default component.exports